<script>
import bem from '@/utils/bem';

const desktopStyles = bem('promo-banner');
const mobileStyles = bem('promo-banner-mobile');

export default {
  props: {
    typePreview: {
      type: Boolean,
      default: false,
      required: true,
    },
    responsiveStyle: {
      type: Function,
      required: true,
    },
    onSelectCssEdit: {
      type: Function,
      required: true,
    },
    selectedStep: {
      type: Number,
      required: true,
    },
    checkedStep: {
      type: Object,
      required: true,
    },
    styleStep: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      email: '',
      firstName: '',
      b: this.typePreview ? mobileStyles : desktopStyles,
    };
  },
};
</script>

<template>
  <div :class="b('content-block')">
    <span
      v-if="!typePreview && checkedStep.title"
      :class="b('step-title')"
      role="button"
      tabindex="-1"
      @click="onSelectCssEdit('titleStyles')"
      @keydown="onSelectCssEdit('titleStyles')"
      :style="responsiveStyle(styleStep.titleStyles)"
    >
      {{ checkedStep.title }}
    </span>
    <span
      v-if="checkedStep.subtitle"
      :class="b('step-subtitle')"
      role="button"
      tabIndex="-1"
      @click="onSelectCssEdit(typePreview ? 'subtitleMobileStyles' : 'subtitleStyles')"
      @keydown="onSelectCssEdit(typePreview ? 'subtitleMobileStyles' : 'subtitleStyles')"
      :style="typePreview
          ? responsiveStyle(styleStep.subtitleMobileStyles)
          : responsiveStyle(styleStep.subtitleStyles)"
    >
      {{ checkedStep.subtitle }}
    </span>
    <span
      v-if="checkedStep.body"
      :class="b('step-text')"
      role="button"
      tabIndex="-1"
      @click="onSelectCssEdit(typePreview ? 'bodyMobileStyles' : 'bodyStyles')"
      @keydown="onSelectCssEdit(typePreview ? 'bodyMobileStyles' : 'bodyStyles')"
      :style="typePreview
          ? responsiveStyle(styleStep.bodyMobileStyles)
          : responsiveStyle(styleStep.bodyStyles)"
    >
      {{ checkedStep.body }}
    </span>
    <button
      v-if="selectedStep === 0"
      :class="b('step-btn', { big: !typePreview })"
      type="button"
      @click="() => {
      // toggleNotification(true);
      // delayCloseNotification();
      // redirect()
      }"
    >
      {{ checkedStep.buttonText }}
    </button>
    <div :class="b('input-block')" v-if="selectedStep === 1">
      <Formkit
        type="form"
        :value="{email: '', firstName: ''}"
        submit-label="Save"
      >
        <FormKit
          name="firstName"
          label="firstName"
          validation="required"
        />
        <FormKit
          name="email"
          label="Email address"
          validation="required|email"
        />
      </Formkit>
    </div>
    <button
      v-if="selectedStep === 2"
      :class="b('step-btn')"
      type="button"
      title="codeButton"
    >
    </button>
    <span
      v-if="checkedStep.disclaimerText"
      :class="b('step-bottom-text')"
      role="button"
      tabIndex="-1"
      @click="onSelectCssEdit(typePreview ? 'disclaimerMobileStyles' : 'disclaimerStyles')"
      @keydown="onSelectCssEdit(typePreview ? 'disclaimerMobileStyles' : 'disclaimerStyles')"
      :style="typePreview
          ? responsiveStyle(styleStep.disclaimerMobileStyles)
          : responsiveStyle(styleStep.disclaimerStyles)"
    >
      {{ checkedStep.disclaimerText }}
    </span>
    <div v-if="countDown && selectedStep === 0" :class="b('step-expires-block')">
      <span :class="b('expires-block-text')">{{ countDownText }}</span>
      <span :class="b('expires-block-time')">
        <Countdown date={newEndDate} daysInHours />
      </span>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./styles.scss"></style>
